import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import curriculumvitae from "../views/curriculumVitae.vue";
import research from "../views/research.vue";
import publication from "../views/publication.vue";
import project from "../views/project.vue";
import studentAwards from "../views/studentAward.vue";
import higherEduSproutProject from "../views/higherEduSproutProject.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "TSUNG-HUNG LIN | 首頁 Home",
    },
  },
  {
    path: "/curriculumvitae",
    name: "curriculumvitae",
    component: curriculumvitae,
    meta: {
      title: "TSUNG-HUNG LIN | 個人介紹 Curriculem Vitae",
    },
  },
  {
    path: "/research",
    name: "research",
    component: research,
    meta: {
      title: "TSUNG-HUNG LIN | 研究方向、國際證照 Research & Certification",
    },
  },
  {
    path: "/publication",
    name: "publication",
    component: publication,
    meta: {
      title: "TSUNG-HUNG LIN | 論文、著作、發明 Publicaiton",
    },
  },
  {
    path: "/project",
    name: "project",
    component: project,
    meta: {
      title: "TSUNG-HUNG LIN | 學生專題競賽獲獎 Student Special Awards",
    },
  },
  {
    path: "/studentawards",
    name: "studentAwards",
    component: studentAwards,
    meta: {
      title: "TSUNG-HUNG LIN | 計畫、產學 Project",
    },
  },
  {
    path: "/higherEduSproutProject",
    name: "higherEduSproutProject",
    component: higherEduSproutProject,
    meta: {
      title:
        "TSUNG-HUNG LIN | 高教深耕計畫成果 Higher Education Sprout Project",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  //beforeEach是router的函式，在進入router前進行判斷
  if (to.meta.title) {
    //判斷是否有tile
    console.log(to.meta.title);
    document.title = to.meta.title;
  } else {
    document.title = "TSUNG-HUNG LIN";
  }
  next();
});

export default router;
